export default (invoiceNavigationId) => {
  let isMobile = false
  if( window.innerWidth < 576 ) {
    isMobile = true
  }

  if( isMobile ) {
    const invoiceNavigationElement = document.querySelector(invoiceNavigationId)
    if (!invoiceNavigationElement) {
      return
    }

    invoiceNavigationElement.addEventListener('click', (event) => {
      invoiceNavigationElement.classList.toggle('visible')
    })
  }
}
